import { modalTypes } from "constants/types";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";

const useShowArchiveEntityModal = () => {
  const dispatch = useDispatch();

  return useCallback(
    ({ primarySlot, entityName, optionalSlot, cascadeWarning, onConfirm }) => {
      dispatch(
        showModal(modalTypes.ARCHIVE_ENTITY_MODAL, {
          primarySlot,
          entityName,
          optionalSlot,
          cascadeWarning,
          onConfirm,
        })
      );
    },
    [dispatch]
  );
};

export default useShowArchiveEntityModal;
